@if (carouselSlides != null && isInitialized) {
    <div class="PGCarousel {{ fullScreen ? 'PGCarousel--FullScreen' : '' }}">
        <button class="PGCarousel-Button {{currentSlide > 0 ? 'PGCarousel-Button--Visible' : ''}} btn btn-white" (click)="goPrev()"><i class="fa-regular fa-chevron-left"></i></button>
        <ng-content></ng-content>
        @if (carouselSlides.length > 0) {
            <div class="PGCarousel-Index">
                @for (slide of carouselSlides; track slide; let i = $index) {
                    <div class="PGCarousel-Index-Element {{currentSlide == i ? 'PGCarousel-Index-Element--Selected' : ''}}" (click)="goTo(i)">
                    </div>
                }
            </div>
        }
        <button class="PGCarousel-Button {{currentSlide < maxSlide ? 'PGCarousel-Button--Visible' : ''}} btn btn-white" (click)="goNext()"><i class="fa-regular fa-chevron-right"></i></button>
    </div>
}